import { Logger } from '../logger/interfaces';
import { useServices } from './useServices';

export function useLogger(): Logger {
  const { logger } = useServices();
  return logger;
}
